//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import ImageLayerLegend from '~/components/molecules/Editorial/ImageLayerLegend.vue';
import ParagraphTitle from '~/components/atoms/Editorial/ParagraphTitle.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import Cta from '~/components/atoms/Cta.vue';
import { EMPTY_PIXEL } from '~/const/images';
import { formatPrismicImage } from '~/helpers/image-helper';
var COLORS = {
  grey: 'primary',
  transparent: 'transparent'
};
export default {
  name: 'IntroImageCta',
  components: {
    ImageLayerLegend,
    ParagraphTitle,
    SimpleParagraph,
    Cta
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  computed: {
    paragraphTitle() {
      return this.payload.primary.paragraph_title || [];
    },

    simpleParagraph() {
      return this.payload.primary.simple_paragraph || [];
    },

    readMore() {
      return this.payload.primary.read_more === 'Yes';
    },

    button() {
      return {
        textBtn: this.payload.primary.button_text || '',
        type: COLORS[this.payload.primary.button_color] || 'primary',
        url: this.payload.primary.button_url.url || '',
        target: this.payload.primary.button_url.target,
        tracking: {
          data: {
            event_category: this.payload.primary.button_event_category,
            event_action: this.payload.primary.button_event_action,
            event_label: this.payload.primary.button_event_label
          }
        }
      };
    },

    elements() {
      return this.payload.items.map(item => {
        var xsmall = formatPrismicImage(item.image.url, ['w_100']) || EMPTY_PIXEL;
        var small = formatPrismicImage(item.image.url, ['w_375']) || EMPTY_PIXEL;
        var medium = formatPrismicImage(item.image.url, ['w_375,dpr_2']) || EMPTY_PIXEL;
        var large = formatPrismicImage(item.image.url, ['w_600,dpr_2']) || EMPTY_PIXEL;
        var xlarge = formatPrismicImage(item.image.url, ['w_800,dpr_2']) || EMPTY_PIXEL;
        return {
          src: large,
          srcset: "".concat(xsmall, " 100w, ").concat(small, " 375w, ").concat(medium, " 750w, ").concat(large, " 1200w, ").concat(xlarge, " 1600w"),
          alt: item.alt,
          ratio: item.ratio,
          layer: this.typeLayer(item.layer),
          context: item.context,
          reference: item.reference,
          legend: item.legend,
          negativeText: this.negative(item.negative_text),
          tracking: {
            data: {
              event_category: item.event_category,
              event_action: item.event_action,
              event_label: item.event_label
            }
          }
        };
      });
    }

  },
  methods: {
    negative(arg) {
      return arg === 'black';
    },

    typeLayer(arg) {
      return arg === 'no';
    }

  }
};